// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.post_img-content__5rKN9 {
  border-radius: 14px;
  width: 100%;
  aspect-ratio: 16/9 !important; /* Tỷ lệ hình chữ nhật  */
  object-fit: cover;
}
.post_img-content__5rKN9:hover {
  transform: scale(1.05);
  transition: transform 0.4s ease-in-out;
  cursor: pointer;
}

.post_custom-card__plmoT {
  border: none;
  cursor: pointer;
}

.post_title-container__WZ1Yt {
  position: relative;
  max-width: 100%;
}

.post_title-content__RDonF {
  font-weight: 600;
  font-size: 2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 60px); /* Trừ không gian cho badge */
}

.post_vip-badge__Qp3yp {
  font-size: 1.4rem;
  position: absolute;
  top: 0;
  right: 0;
}

.post_title__Pc\\+xv {
  font-weight: 700;
  font-size: 4rem;
}

.post_showAll-btn__Hn1g8 {
  font-size: 1.8rem;
  color: rgb(108, 117, 125);
}

@media (max-width: 768px) {
  .post_title__Pc\\+xv {
    font-size: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/content/post/getItem/post.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACI,mBAAA;EACA,WAAA;EACA,6BAAA,EAAA,yBAAA;EACA,iBAAA;AAAJ;AAGI;EACI,sBAAA;EACA,sCAAA;EACA,eAAA;AADR;;AAIA;EACI,YAAA;EACA,eAAA;AADJ;;AAGA;EACI,kBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA,EAAA,6BAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;AAAJ;;AAEA;EACI,iBAAA;EACA,yBAAA;AACJ;;AAEA;EACI;IACI,eAAA;EACN;AACF","sourcesContent":["\n\n.img-content{\n    border-radius: 14px;\n    width: 100%; \n    aspect-ratio: 16 / 9 !important; /* Tỷ lệ hình chữ nhật  */\n    object-fit: cover;    \n\n\n    &:hover{\n        transform: scale(1.05); \n        transition: transform 0.4s ease-in-out; \n        cursor: pointer;\n    }\n}\n.custom-card {\n    border: none;\n    cursor: pointer;\n}\n.title-container {\n    position: relative;\n    max-width: 100%;\n}\n\n.title-content {\n    font-weight: 600;\n    font-size: 2rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: calc(100% - 60px); /* Trừ không gian cho badge */\n}\n\n.vip-badge {\n    font-size: 1.4rem;\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n//post\n.title{\n    font-weight: 700;\n    font-size: 4rem;\n}\n.showAll-btn{\n    font-size: 1.8rem;\n    color:rgb(108 117 125);\n}\n\n@media (max-width: 768px) {\n    .title{\n        font-size: 3rem;\n    }\n  }\n  \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img-content": `post_img-content__5rKN9`,
	"custom-card": `post_custom-card__plmoT`,
	"title-container": `post_title-container__WZ1Yt`,
	"title-content": `post_title-content__RDonF`,
	"vip-badge": `post_vip-badge__Qp3yp`,
	"title": `post_title__Pc+xv`,
	"showAll-btn": `post_showAll-btn__Hn1g8`
};
export default ___CSS_LOADER_EXPORT___;
